export class GroupDeleteModel {
    public assignorGuid: string;
    public managerGuid: string;
}